"use strict";

module.exports = {

  Desktop: {
    GUTTER: 24,
    GUTTER_LESS: 16,
    INCREMENT: 64,
    MENU_ITEM_HEIGHT: 32
  },

  getIncrementalDim: function getIncrementalDim(dim) {
    return Math.ceil(dim / this.Desktop.INCREMENT) * this.Desktop.INCREMENT;
  }
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/material-ui/lib/utils/key-line.js
 ** module id = 282
 ** module chunks = 0
 **/